import * as userStorageService from '../services/user-storage-service';

const STORAGE_KEY = 'sidebar';

export const fetchSidebarConfig = () => {
    return userStorageService.get(STORAGE_KEY);
}

export const expandSidebar = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        expanded: true
    }));
}

export const collapseSidebar = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        expanded: false
    }));
}
